<template>
  <div>
    <PageHeader title="Offres" />
    <Table :columns="columns" :data="contractDistributions" :isAccessible="true" @view="rowClick" />
    <Pagination
      :currentPage="currentPage"
      :totalPages="totalPages"
      :totalCount="totalCount"
      @changePage="handleChangePage"
    />
  </div>
</template>

<script>
import { PageHeader, Pagination, Table } from "@estaly/ui";
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  components: { PageHeader, Pagination, Table },

  data: () => {
    return {
      contractDistributions: [],
      columns: [{ label: "Formule", field: "translatedCategory" }],
    };
  },

  created() {
    this.getContractDistributions();
  },

  computed: {
    ...mapGetters("store", ["selectedStoreId"]),
    ...mapState("contractDistributions", {
      currentPage: (state) => state.currentPage,
      totalPages: (state) => state.totalPages,
      totalCount: (state) => state.totalCount,
    }),
  },

  methods: {
    ...mapActions("contractDistributions", { fetchContractDistributions: "fetchIndex" }),
    async getContractDistributions(page = 1) {
      const data = await this.fetchContractDistributions({
        storeId: this.selectedStoreId,
        page,
      });

      this.contractDistributions = data?.contractDistributions;
    },

    handleChangePage(page) {
      this.getContractDistributions(page);
    },

    rowClick(row) {
      this.$router.push(`${this.$route.path}/${row.id}`);
    },
  },
};
</script>
